import Grid from "@mui/material/Unstable_Grid2";

export default function BigCardGrid({children,...props}) {
    return (<Grid xs={12} sm={6} md={4} {...props}>{children}</Grid>);
}